import {
  getManagedAbsenceUsers,
  UserAutocompleteField,
  useResourceUsers,
} from '@src/features/absence';
import { useAuthentication } from '@src/features/auth';
import { useMemo } from 'react';

type UsersFieldProps = {
  disabled?: boolean;
};

export default function UsersField({ disabled = false }: UsersFieldProps) {
  const { user } = useAuthentication();
  const { users } = useResourceUsers();
  const availableUsers = useMemo(
    () => getManagedAbsenceUsers(users, user),
    [users, user],
  );

  return (
    <UserAutocompleteField
      disabled={disabled}
      label="For"
      name="userId"
      users={availableUsers}
      size="large"
      required
    />
  );
}
